<div class="wrapper">
    <div [class]="columnClass" *ngFor="let articleGroup of knowledgeBaseItemGroups">
        <wuc-list icon="arrow" [expanded]="true">
            <wuc-list-item *ngFor="let article of articleGroup">
                <wuc-link
                    type="tertiary"
                    [route]="article?.url"
                    [linkTitle]="article?.title"
                >
                    <span [innerHtml]="article?.title | wucSafeHtml"></span>
                </wuc-link>
            </wuc-list-item>
        </wuc-list>
    </div>
</div>
